import convinboss from './convinboss.vue'

export default convinboss
